"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/186c4ed5-d146-49dc-a80d-5f439e39d5e9
 * name: IcInfoMiddle
 */
function IcInfoMiddle() {
    return null;
}
exports.default = IcInfoMiddle;
;
